import { render, staticRenderFns } from "./GnpiAndXolPremiums.vue?vue&type=template&id=b2b464f2&"
import script from "./GnpiAndXolPremiums.vue?vue&type=script&lang=js&"
export * from "./GnpiAndXolPremiums.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports